import { Pipe, PipeTransform } from '@angular/core';

/* Dash format ("866-799-2728") for the EAP numbers shown beside CTAs (R5).
   PhonePipe's "(866) 799-2728" style stays on the FAQ contact block. */
@Pipe({ name: 'phoneDash' })
export class PhoneDashPipe implements PipeTransform {
	transform(str: string) {
		if (!str) { return ''; }
		const digits = str.replace(/\D/g, '');
		if (digits.length !== 10) { return str; }
		return `${digits.substring(0, 3)}-${digits.substring(3, 6)}-${digits.substring(6)}`;
	}
}
